import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../features/modal/ModalSlice";
import CustomInputBox from "../../Form/CustomInputBox";
import { Numbers, Pause, Phone, PlayArrow } from "@mui/icons-material";
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
  Divider,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import CustomButton from "../../Button/CustomButton";
import apiClient from "../../../services/apiClient";
import { useNavigate } from "react-router-dom";
import { LuFileInput, LuTextCursorInput } from "react-icons/lu";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { FiHash } from "react-icons/fi";
import { RiVoiceprintFill } from "react-icons/ri";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { FaUserTie, FaRobot } from "react-icons/fa6";
import { AiOutlineCode } from "react-icons/ai";
import FileUrlInput from "../../Form/FileUrlInput";

const AddAiAgent = () => {
  const [formData, setFormData] = useState({
    agent_name: "",
    model_name: "llama",
    // model_id: "",
    raw_text: "",
    website_url: "",
    assigned_voice_type: "",
    personality: "",
    sales_script: "",
  });

  const [text, setText] = useState("");
  const [files, setFiles] = useState([]);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [voiceData, setVoiceData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo.user);
  const [playingId, setPlayingId] = useState(null);
  const [audio, setAudio] = useState(null);

  const handlePlay = (ele) => {
    if (audio) {
      audio.pause();
      setAudio(null);
      setPlayingId(null);
    }

    if (playingId !== ele._id) {
      const newAudio = new Audio(
        `https://dialgrid-api.greymatterz.com/${ele.sample_voice.replace(/\\/g, "/")}`
      );
      newAudio.play();
      setAudio(newAudio);
      setPlayingId(ele._id);

      newAudio.onended = () => {
        setPlayingId(null);
        setAudio(null);
      };
    }
  };

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    fetchVoice();
  }, []);

  const fetchVoice = async () => {
    try {
      const response = await apiClient.get("/agent-voice");
      const data = response?.data || [];
      // console.log(data);
      setVoiceData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const validate = () => {
    let tempErrors = {};
    if (formData.no_of_phones_required > 2) {
      tempErrors.no_of_phones_required = "You can request maximum up to 2 numbers";
    }
    if (formData.extension_start_range <= 10000) {
      tempErrors.extension_start_range = "Extension start range must be greater than 10000";
    }
    if (formData.extension_start_range >= formData.extension_end_range) {
      tempErrors.extension_range = "Extension start range must be smaller than extension end range";
    }
    if (formData.extension_end_range - formData.extension_start_range > 5) {
      tempErrors.extension_range = "You can request a maximum of 5 extensions";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const payload = new FormData();

    // Append files
    files.forEach((file, index) => {
      payload.append(`files[]`, file); // You can use file.name if needed
    });

    // Append Form fields
    Object.entries(formData).forEach(([key, value]) => {
      payload.append(key, value);
    });

    payload.append("user_id", userInfo?.id);

    try {
      await apiClient.post("/create-agent", payload);

      // fetchRequests();
      handleClosePopup();
      navigate("/ai-agent");
    } catch (error) {
      console.error("Error Creating AI Agent:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={"rightModal taskModal"} style={{ width: "450px", }}>
      {/* Header */}
      <Box
        sx={{
          p: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <FaRobot style={{ color: "white", fontSize: 24 }} />
          <Typography variant="h5" sx={{ color: "white", fontWeight: 600, m: 0 }}>
            Create AI Agent
          </Typography>
        </Box>
        <button
          className="btnClose"
          onClick={handleClosePopup}
          style={{
            background: "rgba(255, 255, 255, 0.2)",
            border: "none",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
          }}
        >
          <IoCloseOutline style={{ color: "white", fontSize: 20 }} />
        </button>
      </Box>

      <Divider />

      {/* Body */}
      <Box sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
          Configure your AI agent by providing personality traits, sales scripts, and voice settings. This agent will handle automated conversations for your team.
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={3}>
            {/* Agent Name */}
            <div className="inputData withIcon">
              <span className="icon">
                <LuTextCursorInput />
              </span>
              <input
                className="form-control"
                type="text"
                name="agent_name"
                required
                onChange={handleChange}
              />
              <label className="label">Agent Name</label>
            </div>

            {/* File/URL Input */}
            <div className="inputData withIcon">
              <FileUrlInput
                text={formData?.raw_text}
                setText={(text) => setFormData((prev) => ({ ...prev, raw_text: text }))}
                files={files}
                setFiles={setFiles}
              />
            </div>

            {/* Website URL */}
            <div className="inputData withIcon">
              <span className="icon">
                <LuTextCursorInput />
              </span>
              <input
                className="form-control"
                type="text"
                name="website_url"
                required
                onChange={handleChange}
              />
              <label className="label">Website URL</label>
            </div>

            {/* AI Voice Selector */}
            <div className="inputData selectForm">
              <span className="icon">
                <RiVoiceprintFill />
              </span>

              <FormControl fullWidth>
                <InputLabel>Choose AI Voice</InputLabel>
                <Select
                  name="assigned_voice_type"
                  value={formData.assigned_voice_type || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      assigned_voice_type: e.target.value,
                    }))
                  }
                  renderValue={(selected) => {
                    const voice = voiceData.find((v) => v._id === selected);
                    return voice ? voice.voice_name : "Choose AI Voice";
                  }}
                  sx={{
                    "& .MuiSelect-select": {
                      padding: "12.5px 46px",
                    },
                  }}
                >
                  {voiceData.map((ele) => (
                    <MenuItem key={ele._id} value={ele._id}>
                      <ListItemText primary={ele.voice_name} />
                      <IconButton onClick={() => handlePlay(ele)} size="small">
                        {playingId === ele._id ? <Pause /> : <PlayArrow />}
                      </IconButton>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Personality Define */}
            <div className="inputData textareaData withIcon">
              <span className="icon">
                <FaUserTie />
              </span>
              <textarea
                className="form-control h-auto"
                rows="5"
                cols="80"
                required
                name="personality"
                value={formData.personality}
                onChange={handleChange}
              ></textarea>
              <label className="label">Personality Define</label>
            </div>

            {/* Sales Script */}
            <div className="inputData textareaData withIcon">
              <span className="icon">
                <AiOutlineCode />
              </span>
              <textarea
                className="form-control h-auto"
                rows="5"
                cols="80"
                required
                name="sales_script"
                value={formData.sales_script}
                onChange={handleChange}
              ></textarea>
              <label className="label">Sales Script</label>
            </div>

            {/* Info Box */}
            <Box
              sx={{
                p: 2,
                backgroundColor: "#F0F9FF",
                borderRadius: "8px",
                border: "1px solid #BAE6FD",
                display: "flex",
                gap: 1.5,
              }}
            >
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  backgroundColor: "#0EA5E9",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: "bold",
                  flexShrink: 0,
                }}
              >
                i
              </Box>
              <Typography variant="body2" sx={{ color: "#0369A1", fontSize: "0.875rem", lineHeight: 1.6 }}>
                AI agents can handle automated conversations based on the personality and sales script you define. Choose a voice that best represents your brand.
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Box>

      <Divider />

      {/* Footer */}
      <Box className="d-flex rightModalFooterBtn" sx={{ borderTop: "1px solid #E5E7EB" }}>
        <CustomButton
          type="button"
          variant="contained"
          onClick={handleClosePopup}
          disabled={loading}
          sx={{
            minWidth: "40%",
            borderRadius: "0px",
            backgroundColor: "#FFFFFF",
            color: "#333",
            padding: "14px 16px",
            fontWeight: 500,
            fontSize: "0.938rem",
            boxShadow: "none",
            borderRight: "1px solid #E5E7EB",
            "&:hover": {
              backgroundColor: "#F9FAFB",
              boxShadow: "none",
            },
            "&:disabled": {
              backgroundColor: "#F3F4F6",
              color: "#9CA3AF",
            },
          }}
        >
          Cancel
        </CustomButton>
        <CustomButton
          type="submit"
          variant="contained"
          onClick={handleSubmit}
          loading={loading}
          sx={{
            minWidth: "60%",
            borderRadius: "0px",
            backgroundColor: "#667eea",
            color: "#FFFFFF",
            padding: "14px 16px",
            fontWeight: 600,
            fontSize: "0.938rem",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#5568d3",
              boxShadow: "none",
            },
            "&:disabled": {
              backgroundColor: "#E5E7EB",
              color: "#9CA3AF",
            },
          }}
        >
          Create Agent
        </CustomButton>
      </Box>
    </div>
  );
};

export default AddAiAgent;
